/**
 * Copyright 2025 Google LLC. This software is provided as-is, without warranty 
 * or representation for any use or purpose. Your use of it is subject to your 
 * agreement with Google.
 */
import { Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SafeHtmlPipe } from '../services/safe-html.pipe';
import { DatePipe, NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'app-preview-citation',
  standalone: true,
  imports: [MatIconModule, SafeHtmlPipe, NgFor, NgIf],
  templateUrl: './preview-citation.component.html',
  styleUrl: './preview-citation.component.scss',
})
export class PreviewCitationComponent {
  @Input('isMobileView') isMobileView!: boolean;
  @Input('selectedCitation') selectedCitation: any;
  @Input('previewPanelError') previewPanelError!: boolean;
  @Input('previewPanelHeight') previewPanelHeight: any;
  @Output() closePreviewSection = new EventEmitter<boolean>();
  @ViewChild('previewPanel') previewPanel!: ElementRef;

  ngOnInit() {
    this.setPreviewPanelHeight();
  }
  ngOnChanges() {
    this.setPreviewPanelHeight();
  }
  ngAfterViewInit() {
    this.setPreviewPanelHeight();
  }

  setPreviewPanelHeight() {
    if (!this.isMobileView && this.previewPanel) {
      this.previewPanel.nativeElement.style.height = `${this.previewPanelHeight}px`;
      this.previewPanel.nativeElement.style.maxWidth = `360px`;
    }
  }

  displayLastEditDate(last_update_date: any): any {
    let date = new DatePipe('en-US')
    return date.transform(last_update_date, 'MM/dd/yyyy'); 
  }

  modifyContent(content: any) {
    if (content.includes('[[HIGHLIGHT]]')) {
      let res = content.replaceAll("[[HIGHLIGHT]]", "<a style='background:yellow'>");
      res = res.replaceAll("[[/HIGHLIGHT]]", "</a>");
      return res;
    }
    else {
      return content;
    }
  }

  closePreview() {
    this.closePreviewSection.emit(true);
  }
}
